import { render, staticRenderFns } from "./ancestralGenealogy.vue?vue&type=template&id=015f1090&scoped=true"
import script from "./ancestralGenealogy.vue?vue&type=script&lang=js"
export * from "./ancestralGenealogy.vue?vue&type=script&lang=js"
import style0 from "./ancestralGenealogy.vue?vue&type=style&index=0&id=015f1090&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "015f1090",
  null
  
)

export default component.exports